import { Flex, Image, Text } from '@podiumhq/design-system';
import GoogleStars from '../../components/GoogleStars';
import googleLogo from '../../assets/google.svg';

export const testimonialText =
  '“We went from an average 4.2 star rating to 4.8. This was possible because we were able to easily send review requests through Podium.”';
export const testimonialAttribution = 'Brooklyn Simmons | Sheridan Realty';

export const businessContent = (
  <Text color="black.base" fontSize="sm">
    Hi Taylor! Thanks for choosing us, would you leave us a review?
  </Text>
);

export const googleIcon = <Image w="24px" src={googleLogo} mr="8px" />;

export const customerTextContent = (
  <>
    <Flex mb="10px" alignItems="center">
      <Image src={googleLogo} alt="Google logo" w="24px" mr="8px" />
      <GoogleStars />
    </Flex>
    <Text color="black.base" fontSize="sm">
      Excellent service. Sam at the front desk was very knowledgeable and...
    </Text>
  </>
);
